import { configureStore } from "@reduxjs/toolkit";
import { userLoginReducers,userRegisterReducers } from "../reducers/userReducers";

export const store = configureStore({
  reducer: { userLogin : userLoginReducers,userSignUp:userRegisterReducers}
});